import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '名称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'level',
    fieldName: '紧急程度'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'icon',
    fieldName: '图标'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'maxCompletedDays',
    fieldName: '最大完成天数'
  }
]
